import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import {simpleSlashes} from "../../lib/Utilities";
import {Link, useNavigate} from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ActionButton from "../button/button.component";

interface Site {
    name: string;
    url?: string;
}

interface ComponentProps {
    sites: Array<Site>;
}

export default function SiteBreadCrumb({sites = []}: ComponentProps) {
    const navigate = useNavigate();

    const renderSites = (sites: Site[]) => {
        let url = "";

        return sites.map((site: Site, i: number) => {
            url += site.url;
            url = simpleSlashes(url);

            return <Link
                key={site + " " + i}
                to={url}
                target={"_self"}
                style={{
                    textDecoration: "none",
                    color: "inherit",
                    pointerEvents: "none"
                }}
            >
                <Typography variant="h5">{site.name.toLowerCase()}</Typography>
            </Link>
        })
    }

    const handleStepBack = () => {
        if (sites.length == 1) {
            return;
        }

        let beforeLastUrl = "";

        sites.slice(0, sites.length - 1).forEach(site => {
            beforeLastUrl += site.url;
            beforeLastUrl = simpleSlashes(beforeLastUrl);
        });

        navigate(beforeLastUrl);
    }

    return (
        <div role="presentation">
            <Breadcrumbs aria-label="breadcrumb">
                {
                    sites && sites.length > 0 && renderSites(sites)
                }
            </Breadcrumbs>
            <ActionButton title={'Vissza az előző menübe'} type={"STEP_BACK"} icon={<ArrowBackIcon/>}
                          action={handleStepBack}/>
            <br/>
            <br/>
        </div>
    );
}